import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Quick and easy way to getting burned by nginx",
  "description": "",
  "published": "2011-10-05T00:00:00.000Z",
  "redirect_from": ["/blog/quick-and-easy-way-to-getting-burned-by-nginx/swizec/2572"],
  "categories": "Linux, Nginx, Server, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/2990635787_f61ba8ce93_m1.jpg",
        "alt": "HTTP 403: Forbidden",
        "title": "HTTP 403: Forbidden"
      }}></img></p>
    <p>{`A couple of hours ago I was talking about my past and current projects with someone and they mentioned that Hipstervision was down. Returning a nasty `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/HTTP_403",
        "title": "HTTP 403"
      }}>{`403 error`}</a>{`.`}</p>
    <p>{`What the hell?`}</p>
    <p>{`I know I've left that site fall by the wayside lately as I was focusing on other things, but it should nevertheless at least respond with `}<em parentName="p">{`something`}</em>{` when you try visiting it.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.nginx.org/",
        "title": "Nginx"
      }}>{`Nginx`}</a>{` was running. Node.js processes were running as well. And yet, the 403 error persisted.`}</p>
    <p>{`Restarted everything. Went through all the relevant configurations and still .. nothing. Everything checks out. It makes absolutely no sense for the damn site to be returning a 403.`}</p>
    <p>{`So I try some other sites running on the same server. All but one return a 403.`}</p>
    <p>{`Whaaat? O.o`}</p>
    <p>{`And then I tried a particular document from the working site, on a different domain. It worked. Served the document flawlessly.`}</p>
    <p>{`But ... dear Nginx, I'm using server_name things, you were supposed to treat each domain as a somewhat different server and respond accordingly. I mean, come on, this is technology from the late 1990's when people realized it might be useful to have more than one website per server.`}</p>
    <p>{`Turns out in all config files I had this:`}</p>
    <pre><code parentName="pre" {...{}}>{`server {
    listen 80;
        server_name hipstervision.org;
`}</code></pre>
    <p>{`But on that particular site I had:`}</p>
    <pre><code parentName="pre" {...{}}>{`server {
    listen my-ip:80;
        server_name something.something;
`}</code></pre>
    <p>{`Not sure why that was the case, but apparently Nginx pushes all requests to the most specific `}<em parentName="p">{`listen`}</em>{` rule first and only worries about domains and server names later.`}</p>
    <p>{`Good to know!`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.kevinworthington.com/nginx-for-mac-os-x-lion-in-2-minutes/"
        }}>{`Nginx for Mac OS X Lion in 2 minutes`}</a>{` (kevinworthington.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.kevinworthington.com/nginx-1-1-2-for-windows/"
        }}>{`Nginx 1.1.2 for Windows`}</a>{` (kevinworthington.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://sascho.wordpress.com/2011/10/01/installing-nginx-with-php5-and-php-fpm-and-mysql-support-on-centos-6-0/"
        }}>{`Installing Nginx With PHP5 (And PHP-FPM) And MySQL Support On CentOS 6.0`}</a>{` (sascho.wordpress.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=68da6e63-59a0-45b6-9697-bbee074199fe",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      